import React from 'react';

import Settings from '../settings';

import OpenUrlDialog from './open-url-dialog.jsx';
import SaveDialog from './save-dialog.jsx';
import SettingsDialog from './settings-dialog.jsx';

const { $ } = window;

export default class Toolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project,

      showOpenUrlDialog: false,
      showSaveDialog: false,
      showSettingsDialog: false,

      showAutosaveBtn: Settings.get('autosave', 1) != 0
    };

    let viewportEl = document.getElementById('viewport');
    viewportEl.ondrop = (e) => {
      e.preventDefault();

      this.__loadFiles(e.dataTransfer.files);
    };
    viewportEl.ondragover = (e) => {
      e.preventDefault();
    };

    Settings.addOnChangeListener(() => {
      this.setState({
        showAutosaveBtn: Settings.get('autosave', 1) != 0
      });
    });
  }

  componentDidMount() {
    $('[data-content]').popup();
  }

  __loadFiles(files) {
    if (!files || files.length == 0)
      return;

    let project = this.state.project;

    let lator_alert = false;
    let pages = [];
    for (let i = 0; i < files.length; i++) {
      let file = files[i];


      if (/\.lator$/.test(file.name.toLocaleLowerCase())) {
        if (files.length > 1) {
          lator_alert = true;
        } else {
          project.ready = false;
          project.update();

          let reader = new FileReader();
          reader.onload = (e) => {
            project.importBinary(new Uint8Array(e.target.result));
          };
          reader.readAsArrayBuffer(file);
          return;
        }
      }

      if (/\.(png|jpg|jpeg|gif|bmp|webp)$/.test(file.name.toLocaleLowerCase())) {
        let page = project.loadPage(window.URL.createObjectURL(file), file.name);
        pages.push(page);
      }
    }

    if (lator_alert) {
      alert('Вы пытаетесь открыть файл .lator вместе с несколькими другими файлами. Файлы данного типа должны открываться лишь наедине. Файл будет проигнорирован.');
    }

    if (pages.length > 0) {
      project.selectPage(pages[0]);
    }
  }

  openFileDialog() {
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,application/x-lator';
    input.multiple = true;
    input.onchange = () => {
      this.__loadFiles(input.files);
    }
    input.click();
  }

  showOpenUrlDialog() {
    this.setState({
      showOpenUrlDialog: true
    });
  }

  showSaveDialog() {
    this.setState({
      showSaveDialog: true
    });
  }

  showSettingsDialog() {
    this.setState({
      showSettingsDialog: true
    });
  }

  save() {
    let data = this.state.project.exportBinary().getData();

    let a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(new Blob([data], { type: 'application/octet-stream' }));
    a.download = this.state.project.name + '.lator';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  createProject() {
    let project = this.state.project;
    project.clear();
  }

  render() {
    let project = this.state.project;

    return (
      <div className="ui basic segment">
        <div className="ui small icon buttons">
          <button className="ui button" data-content="Очистить проект" onClick={this.createProject.bind(this)}>
            <i className="file outline icon" />
          </button>
          <button className="ui button" data-content="Открыть из файла" onClick={this.openFileDialog.bind(this)}>
            <i className="folder open outline icon" />
          </button>
          {false && <button className="ui button" data-content="Открыть по ссылке" onClick={this.showOpenUrlDialog.bind(this)}>
            <i className="cloud download icon" />
          </button>}
          <button className="ui button" data-content="Сохранить" onClick={this.showSaveDialog.bind(this)}>
            <i className="save icon" />
          </button>
        </div>

        <div className="ui small icon buttons">
          <button className="ui button" data-content="Сохранить в своем формате" onClick={this.save.bind(this)} style={{marginLeft: '0.3em'}}>
            <i className="share icon" />
          </button>
        </div>

        <div className="ui small right floated icon buttons">
          <button className="ui button" data-content="Настройки" onClick={this.showSettingsDialog.bind(this)}>
            <i className="setting icon" />
          </button>
        </div>

        <div style={{float: 'right'}}>
          {this.state.showAutosaveBtn &&
            <button className="ui small right floated icon button" data-content="Обновить автосохранение" onClick={() => { this.state.project.makeAutosave() }} style={{marginRight: '0.3em'}}>
              <i className="umbrella icon" />
            </button>
          }
        </div>

        <OpenUrlDialog toolbar={this} visible={this.state.showOpenUrlDialog} />
        <SaveDialog toolbar={this} visible={this.state.showSaveDialog} />
        <SettingsDialog toolbar={this} visible={this.state.showSettingsDialog} />
      </div>
    );
  }
}
